<template>
  <!--
    ********************************************************
    ****   FORMATO NUMERO 8 CARTAS DE LINK COMO EN      ****
    ****   CONVOCATORIAS SALA ADMINISTRATIVA            ****
    ********************************************************
  -->
<div class="container-fluid" >
<div  class="row">
    <div class="caja-link" v-for="(contenido,index) in contenidos" :key="index" :class="columnasContenido(contenido.TamanoDeLaColumna)">
        <a id="Formato8" v-if="contenido.AbrirEnVisor==false" v-on:click="AbrirArchivo(contenido.RutaArchivoCarpeta)" >{{contenido.TextoDelVinculo}}</a>
        <a id="Formato8" v-if="contenido.AbrirEnVisor==true" v-on:click="AbreElVisor(contenido.RutaArchivoCarpeta)" >{{contenido.TextoDelVinculo}}</a>
    </div>
   </div>
   </div>  
</template>

<script>
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import comun from "@/../static/js/comun";
export default {
    props:{
        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-'+columnas
            return respuesta;
        },
        AbreElVisor: function(vinculo) {
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      AbrirArchivo: function(vinculo,forma) {
        
       // console.log("vinculoooooooo::::::::",vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta))
        comun.DescargarDocumentoPDF(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));
         // console.log('abrir archivo '+vinculo)
          //  window.open(vinculo,forma);
        },
    }

}
</script>

<style scoped>
 #Formato8  {
      font-size: 3em;
       font-family: 'Myriad';
      text-align: left;
      padding: 1em;
      transition: all 1s;
      color: black;
      text-align: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      font-weight: 500;
      
  }

#Formato8:hover{
    
   transform: scale(2.9);
   font-size: 3.4em;
}
   #Formato8 {
    text-align: center; 
  }
.caja-link{
    text-align: center;
    margin-top: 1em;
}


</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/RouterHover.vue